<template>
  <div>
    <el-upload
      ref="upload"
      action="/file/upload"
      name="file"
      list-type="picture-card"
      :on-preview="handlePictureCardPreview"
      :on-remove="handleRemove"
      :http-request="uploadFile"
      :file-list="fileList"
      :headers="headers"
      :disabled="disabled"
    >
      <i class="el-icon-plus"></i>
    </el-upload>
    <el-dialog :visible.sync="dialogVisible">
      <img width="100%" :src="dialogImageUrl" alt />
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      dialogImageUrl: "",
      dialogVisible: false,
      fileList: [],
      headers: { Authorization: "Bearer " + this.$store.getters.getToken },
      disabled:false,
    };
  },
  methods: {
    handleRemove(file, fileList) {
      console.log(file, fileList);
        this.fileList = fileList;
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    uploadFile(param) {
      var self = this;
      let formData = new FormData();
      formData.append("file", param.file);
      this.$axios
        .post("/file/upload", formData, {
          headers: {
            "Content-type": "multipart/form-data"
          }
        })
        .then(function(response) {
          if (response.data.errorCode == "00000") {
            console.info(self.$refs.upload.uploadFiles);
            self.fileList.push(response.data.data);
          } else {
            self.$message.error(response.data.errorMsg);
            self.$refs.upload.uploadFiles = [];
          }
        });
    }
  }
};
</script>

<style>
</style>